module.exports = __webpack_public_path__ + "static/media/course_new.3a827de7.png";